import React from 'react'

import { Icon } from '@mui/material'

import type { FC } from 'react'
import type { IconProps } from '@mui/material'

interface SanityIconProps extends IconProps {
  name: string
}

export const SanityIcon: FC<SanityIconProps> = ({ name, ...props }) => {
  return <Icon {...props}>{name.replace('outline', '').replace(/^_+|_+$/g, '')}</Icon>
}
